export default __webpack_public_path__ + "static/capability-terminal-9941beadcfefbb8b2b33b81797cd30a1.png";